import configs from "config";

export default function isFiat(coin: string) {
  return configs.fiats.includes(coin.toLowerCase());
}
